import React, { createContext, useContext, useReducer } from 'react';
import { contactReducer, IContactAction, IContactState, initialState } from './contact-reducer';

const ContactStateContext = createContext<IContactState | undefined>(undefined);
const ContactDispatchContext = createContext<React.Dispatch<IContactAction> | undefined>(undefined);

export function ContactProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(contactReducer, initialState);

    return (
        <ContactStateContext.Provider value={state}>
            <ContactDispatchContext.Provider value={dispatch}>
                {children}
            </ContactDispatchContext.Provider>
        </ContactStateContext.Provider>
    );
}

export function useContactState() {
    const context = useContext(ContactStateContext);
    if (context === undefined) {
        throw new Error('useContactState must be used within a ContactProvider');
    }
    return context;
}

export function useContactDispatch() {
    const context = useContext(ContactDispatchContext);
    if (context === undefined) {
        throw new Error('useContactDispatch must be used within a ContactProvider');
    }
    return context;
}

export { ACTION_TYPES } from './contact-reducer';
